
import rem from "@/utils/rem.js"
import { reactive, ref, watch } from "vue"
import list from './components/List.vue'
import TheServiceItem from "./components/TheServiceItem.vue"
import request from '@/utils/618Request.js'
export default {
  name: "index",
  components: {
    list,
    TheServiceItem
  },
  setup() {
    rem(375, 375)
    const active = ref(0)
    const list = ref(null)
    const state = reactive({
      list: [],
      pageNum: 1
    })

    watch(() => active.value, val => {
      state.list = []
      state.pageNum = 1
      list.value.setFinishedFalse()
    })

    const onClickTab = async () => {
      state.list = [];
      state.pageNum = 1;
    }

    const onRefresh = () => {
      state.list = []
      state.pageNum = 1
    }
    const onLoad = async (callback: Function) => {
      let res = null
      if (active.value == 0) {
        res = await request.get('/temporary/activity/healthProductList', { indexPage: state.pageNum, productId: '51,50,49,48,47,46'})
      }
      if (active.value == 1) {
        res = await request.get('/temporary/activity/healthProductList', { indexPage: state.pageNum, productId: 2 })
      }
      if (res && res.data) {
        state.list = state.list.concat(res.data)
        state.pageNum++
        callback(res.data.length <= 0)
      } else {
        callback(true)
      }
    }

    return {
      active,
      state,
      list,
      onRefresh,
      onLoad,
      onClickTab
    }
  }
}
